import { useState } from "react";
import React from "react";
import SEO from "./SEO";
import { API_BASE_URL } from "../config/api";

const translations = {
  tr: {
    title: "Hızlı Randevu",
    subtitle: "Bilgilerinizi girin, size hemen ulaşalım",
    backToHome: "← Ana Sayfaya Dön",
    phone: { title: "Telefon Numaranız", placeholder: "5__ ___ __ __", button: "Devam" },
    name: { title: "Adınız Soyadınız", placeholder: "Ad Soyad", button: "Devam" },
    message: { title: "Mesajınız", placeholder: "Mesajınızı yazın...", button: "Gönder" }
  },
  en: {
    title: "Quick Appointment",
    subtitle: "Enter your details, we'll contact you soon",
    backToHome: "← Back to Home",
    phone: { title: "Your Phone Number", placeholder: "5__ ___ __ __", button: "Continue" },
    name: { title: "Your Full Name", placeholder: "Full Name", button: "Continue" },
    message: { title: "Your Message", placeholder: "Write your message...", button: "Send" }
  },
  fr: {
    title: "Rendez-vous Rapide",
    subtitle: "Entrez vos coordonnées, nous vous contacterons bientôt",
    backToHome: "← Retour à l'accueil",
    phone: { title: "Votre Numéro", placeholder: "5__ ___ __ __", button: "Continuer" },
    name: { title: "Votre Nom", placeholder: "Nom Complet", button: "Continuer" },
    message: { title: "Votre Message", placeholder: "Écrivez votre message...", button: "Envoyer" }
  }
};

const quickAppointmentStyles = `
  .qa-form-row {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .qa-card {
    padding: 50px;
  }

  @media (max-width: 767px) {
    .qa-form-row {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 10px !important;
    }
    .qa-form-row label {
      min-width: unset !important;
      text-align: center;
    }
    .qa-form-row select {
      width: 100% !important;
    }
    .qa-form-row input {
      width: 100% !important;
    }
    .qa-phone-row {
      flex-direction: row !important;
      align-items: center !important;
    }
    .qa-phone-row select {
      width: 120px !important;
      flex-shrink: 0;
    }
    .qa-phone-row input {
      flex: 1 !important;
    }
    .qa-card {
      padding: 25px 20px !important;
      border-radius: 15px !important;
    }
    .qa-wrapper {
      padding: 15px !important;
      padding-top: 80px !important;
    }
    .qa-title {
      font-size: 28px !important;
    }
    .qa-subtitle {
      font-size: 15px !important;
    }
  }
`;

export const QuickAppointment = ({ lang = "tr", onBack, onSuccess, isDarkMode }) => {
  const [step, setStep] = useState(1);
  const [countryCode, setCountryCode] = useState("+33");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const t = translations[lang] || translations.tr;

  const countryCodes = [
    { code: "+90", flag: "🇹🇷" },
    { code: "+33", flag: "🇫🇷" },
    { code: "+49", flag: "🇩🇪" },
    { code: "+44", flag: "🇬🇧" },
    { code: "+1", flag: "🇺🇸" },
    { code: "+31", flag: "🇳🇱" },
    { code: "+32", flag: "🇧🇪" },
    { code: "+34", flag: "🇪🇸" },
    { code: "+39", flag: "🇮🇹" },
    { code: "+41", flag: "🇨🇭" },
    { code: "+43", flag: "🇦🇹" },
    { code: "+46", flag: "🇸🇪" },
    { code: "+45", flag: "🇩🇰" },
    { code: "+47", flag: "🇳🇴" },
    { code: "+48", flag: "🇵🇱" },
    { code: "+351", flag: "🇵🇹" },
    { code: "+30", flag: "🇬🇷" },
    { code: "+420", flag: "🇨🇿" },
    { code: "+36", flag: "🇭🇺" },
    { code: "+40", flag: "🇷🇴" },
    { code: "+7", flag: "🇷🇺" },
    { code: "+971", flag: "🇦🇪" },
    { code: "+966", flag: "🇸🇦" },
    { code: "+974", flag: "🇶🇦" },
    { code: "+20", flag: "🇪🇬" },
    { code: "+212", flag: "🇲🇦" },
    { code: "+995", flag: "🇬🇪" },
    { code: "+994", flag: "🇦🇿" }
  ];

  const handleNext = () => {
    if (step === 1 && phone.length < 10) return alert("Telefon numarası gerekli");
    if (step === 2 && name.length < 2) return alert("İsim gerekli");
    setStep(step + 1);
  };

  const handleSubmit = async () => {
    if (!message) return alert("Mesaj gerekli");
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/quickappointment/quick-submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber: countryCode + phone, name, message, language: lang })
      });
      if (response.ok && onSuccess) onSuccess();
      else alert("Hata oluştu");
    } catch (error) {
      alert("Bağlantı hatası");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    flex: 1,
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    fontSize: "16px",
    width: "100%",
    boxSizing: "border-box"
  };

  const buttonStyle = {
    width: "100%",
    padding: "16px",
    backgroundColor: loading ? "#ccc" : "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: loading ? "not-allowed" : "pointer",
    transition: "background-color 0.3s ease"
  };

  const labelStyle = {
    color: isDarkMode ? "#fff" : "#333",
    fontWeight: "600",
    fontSize: "16px",
    marginBottom: "5px"
  };

  return (
    <div
      className="qa-wrapper"
      style={{
        minHeight: "100vh",
        backgroundColor: isDarkMode ? "#1a1a1a" : "#f5f5f5",
        backgroundImage: "url('/img/law-photo1.png')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "50px 20px"
      }}
    >
      <style>{quickAppointmentStyles}</style>

      {/* Overlay */}
      <div style={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: isDarkMode ? "rgba(0,0,0,0.6)" : "rgba(0,0,0,0.3)",
        zIndex: 0
      }}></div>

      <div className="container" style={{ position: "relative", zIndex: 1, maxWidth: "800px" }}>
        <div
          className="qa-card"
          style={{
            backgroundColor: isDarkMode ? "rgba(30,30,30,0.98)" : "rgba(255,255,255,0.98)",
            borderRadius: "20px",
            boxShadow: "0 25px 50px rgba(0,0,0,0.2)",
            width: "100%"
          }}
        >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2
              className="qa-title"
              style={{ color: isDarkMode ? "#fff" : "#333", fontSize: "32px", fontWeight: "700", marginBottom: "10px" }}
            >
              {t.title}
            </h2>
            <p
              className="qa-subtitle"
              style={{ color: isDarkMode ? "#aaa" : "#777", fontSize: "16px", margin: 0 }}
            >
              {t.subtitle}
            </p>
          </div>

          {/* Progress Bar */}
          <div style={{ width: "100%", height: "6px", backgroundColor: isDarkMode ? "#333" : "#eee", borderRadius: "10px", marginBottom: "30px" }}>
            <div style={{
              width: `${(step / 3) * 100}%`,
              height: "100%",
              backgroundColor: "#4CAF50",
              borderRadius: "10px",
              transition: "width 0.3s ease"
            }}></div>
          </div>

          {/* Step 1: Phone */}
          {step === 1 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <label style={labelStyle}>{t.phone.title}</label>
              <div className="qa-form-row qa-phone-row">
                <select
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  style={{
                    padding: "15px",
                    borderRadius: "10px",
                    border: "1px solid #ddd",
                    width: "120px",
                    fontSize: "16px",
                    backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                    color: isDarkMode ? "#fff" : "#333"
                  }}
                >
                  {countryCodes.map(c => (
                    <option key={c.code} value={c.code}>{c.flag} {c.code}</option>
                  ))}
                </select>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
                  placeholder={t.phone.placeholder}
                  style={{
                    ...inputStyle,
                    backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                    color: isDarkMode ? "#fff" : "#333"
                  }}
                />
              </div>
              <button onClick={handleNext} style={buttonStyle}>{t.phone.button}</button>
            </div>
          )}

          {/* Step 2: Name */}
          {step === 2 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <label style={labelStyle}>{t.name.title}</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t.name.placeholder}
                style={{
                  ...inputStyle,
                  backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                  color: isDarkMode ? "#fff" : "#333"
                }}
              />
              <button onClick={handleNext} style={buttonStyle}>{t.name.button}</button>
            </div>
          )}

          {/* Step 3: Message */}
          {step === 3 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <label style={labelStyle}>{t.message.title}</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={t.message.placeholder}
                rows="5"
                style={{
                  padding: "15px",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  width: "100%",
                  fontSize: "16px",
                  resize: "none",
                  boxSizing: "border-box",
                  backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                  color: isDarkMode ? "#fff" : "#333"
                }}
              />
              <button onClick={handleSubmit} disabled={loading} style={buttonStyle}>
                {loading ? "..." : t.message.button}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};